import { Redirect, Switch, useLocation, useRouteMatch } from 'react-router-dom';

import { useTransl } from 'shared/lib/i18n';

import CommunityApprovalContainer from './Approval/CommunityApprovalContainer';
import ChooseCommunityContainer from './Community/ChooseCommunityContainer';
import CommunityContainer from './Community/CommunityContainer';
import CommunityMessagesContainer from './Messages/CommunityMessagesContainer';
import CommunitySetupContainer from './Setup/CommunitySetupContainer';

import { checkHasPermissions, isAdmin } from '../../utils';

import permissions from '../../permissions';
import AdminRoute from '../../routes/AdminRoute';
import Route from '../../routes/SentryRoute';
import TabsComponentWithLinks from '../Tabs/TabsComponentWithLinks';
import CommunityApprovalRedirect from './Approval/CommunityApprovalRedirect';

const CommunityRouter = () => {
  const { t } = useTransl();
  const { path, url } = useRouteMatch();
  const location = useLocation();

  const firstLineTabs = [
    {
      label: t('title.community'),
      url: `${url}/list`,
      isHidden: !checkHasPermissions(permissions.view_community_posts),
    },
    {
      label: t('title.contentApproval'),
      url: `${url}/content-approval`,
      isHidden: !checkHasPermissions(permissions.approve_community_post),
    },
    {
      label: t('community.communitySetup'),
      url: `${url}/setup`,
      isHidden: !isAdmin(),
    },
  ];

  return (
    <>
      <TabsComponentWithLinks
        tabData={firstLineTabs}
        currentUrl={location.pathname}
      />
      <Switch>
        <Route
          path={`${path}/list`}
          component={ChooseCommunityContainer}
          exact
        />
        <Route path={`${path}/list/:id`} component={CommunityContainer} exact />
        <Route
          path={`${path}/content-approval`}
          component={CommunityApprovalContainer}
          exact
        />
        <Route
          path={`${path}/content-approval/:postId`}
          component={CommunityApprovalRedirect}
          exact
        />
        <AdminRoute
          path={`${path}/setup`}
          component={CommunitySetupContainer}
          exact
        />
        <Route
          path={`${path}/messages/:id`}
          render={({ match: ownMatch }) => (
            <CommunityMessagesContainer
              baseUrl={`${path}/messages`}
              match={ownMatch}
            />
          )}
        />
        <Route
          path={`${path}/messages`}
          render={({ match: ownMatch }) => (
            <CommunityMessagesContainer
              baseUrl={`${path}/messages`}
              match={ownMatch}
            />
          )}
          exact
        />

        <Route path={`${path}`}>
          <Redirect to={isAdmin() ? `${url}/setup` : `${path}/list`} />
        </Route>
      </Switch>
    </>
  );
};

export default CommunityRouter;
